// extracted by mini-css-extract-plugin
module.exports = {"navigationBar":"NavigationBar_navigationBar__3raOY","logo":"NavigationBar_logo__1bXau","name":"NavigationBar_name__3JqE1"};